import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  margin: ${Spacing.S} 0rem;
  min-width: 16rem;
`;

export const TextContainer = styled.div`
  > span:nth-of-type(1) {
    line-height: 1.5rem;
  }
  > span:nth-of-type(2) {
    margin-top: ${Spacing['3Xs']};
  }
`;

export const CommonSection = styled.div`
  align-items: center;
  color: ${Colors.black};
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0rem;
  white-space: pre-line;
  width: 100%;

  > div {
    align-items: start;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const CustomerSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing.Xxs};
`;

export const IconWrapper = styled.div`
  align-items: center;
  color: ${Colors.blue[100]};
  display: flex;
`;

export const ProjectManagerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
`;
